<template>
  <div id="submission-view">
    <div class="grid-row">
      <div class="column">
        <div class="submission-view-header">
          <h1>{{$_('my_submissions')}}</h1>
          <p>{{$_('my_submissions_text')}}</p>
        </div>
      </div>
    </div>
    <SubmissionResearch />
    <div class="grid-row">
      <div class="column">
        <SubmissionList />
      </div>
    </div>
  </div>
</template>

<script>

import SubmissionResearch from '@/modules/soumission/components/SubmissionResearch';
import SubmissionList from '@/modules/soumission/components/SubmissionList'

export default {
  components: {
    SubmissionResearch,
    SubmissionList
  }
}
</script>